import React from "react";
import PropTypes from "prop-types";

const NavHamburger = ({ className, fill }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      className={`inline-block ${className}`}
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="40"
        height="40"
        fill="#44C8F5"
        className={`fill-current ${fill}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14H32V16H8V14ZM8 19H32V21H8V19ZM32 24H8V26H32V24Z"
        fill="white"
      />
    </svg>
  );
};

NavHamburger.defaultProps = {
  fill: "",
  className: "text-blue-ayana",
};

NavHamburger.propTypes = {
  className: PropTypes.string,
};

export default NavHamburger;
